import { render, staticRenderFns } from "./ArquivoAprovado.vue?vue&type=template&id=1a5be9ac&scoped=true"
import script from "./ArquivoAprovado.vue?vue&type=script&lang=js"
export * from "./ArquivoAprovado.vue?vue&type=script&lang=js"
import style0 from "./ArquivoAprovado.vue?vue&type=style&index=0&id=1a5be9ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5be9ac",
  null
  
)

export default component.exports